export const GET_USERS_URL = '/settings/users';
export const CREATE_USER_URL = '/settings/users';
export const UPDATE_USER_URL = (id) => `/settings/users/${id}`;
export const DELETE_USER_URL = (id) => `/settings/users/${id}`;

export const GET_ROLES_URL = '/settings/roles';
export const GET_ROLE_BY_ID_URL = (id) => `/settings/roles/${id}`;
export const CREATE_ROLE_URL = '/settings/roles';
export const UPDATE_ROLE_URL = (id) => `/settings/roles/${id}`;
export const DELETE_ROLE_URL = (id) => `/settings/roles/${id}`;

export const GET_PERMISSIONS_URL = '/settings/permissions';
export const GET_LOGS_URL = '/settings/logs';
